const openClass = 'overlay--open'

// A class to add an overlay background to the page. Used by offcanvas menus for example.
export class Overlay {
  constructor (extraClass = '') {
    this.elem = document.createElement('div')
    this.elem.classList.add('overlay')
    if (extraClass) {
      this.elem.classList.add(extraClass)
    }

    //    this.elem2 = document.createElement('div')
    //    this.elem2.classList.add('overlay', 'overlay--blur')

    //    document.body.insertBefore(this.elem2, document.body.childNodes[0])
    document.body.insertBefore(this.elem, document.body.childNodes[0])
  }

  open () {
    requestAnimationFrame(() => {
      this.elem.classList.add(openClass)
      //      this.elem2.classList.add(openClass)
    })
  }

  close () {
    requestAnimationFrame(() => {
      this.elem.classList.remove(openClass)
      //      this.elem2.classList.remove(openClass)
    })
  }
}
